// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3W1-0","title":"Images90_title__3F0wB","images":"Images90_images__CNRQz"};